import styled, { css } from "styled-components";
import { Link } from "gatsby-link";
import { Fade as Hamburger } from "hamburger-react";
import { media } from "../Theme/default-theme";
import Icon from "../Icon";

export const Navbar = styled.nav`
  padding: 0 12px 12px 32px;
  transition: 0.5s transform;
  position: fixed;
  display: flex;
  flex-direction: column;
  left: 0;
  top: 60px;
  width: 100%;
  font-weight: 300;
  overflow-y: auto;
  background: #f2f2f2;
  height: calc(100% - 60px);
  transform: ${(p) => (p.isOpen ? `translateX(0)` : `translateX(-100%)`)};

  ${media.mobile} {
    & * {
      font-size: 12px;
    }

    padding-top: 30px;
  }

  ${media.tablet} {
    & * {
      font-size: 16px;
    }

    padding-top: 30px;
  }

  ${media.desktop} {
    & * {
      font-size: 20px;
    }
  }
`;

export const Overlay = styled.div`
  transition: 1s background;
  position: fixed;
  left: 0;
  top: 61px;
  width: 100%;
  height: calc(100% - 60px);
  background: rgba(0, 0, 0, 0.4);
  display: ${(p) => (p.isOpen ? "block" : "none")};
`;

export const StyledUl = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const navTextSize = css`
  font-size: 0.875em;
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  line-height: 1.5em;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  ${navTextSize};
  font-weight: 300;
  color: #696057;

  :hover {
    color: #ff5f00;
  }
`;

export const StyledText = styled.div`
  ${navTextSize};
  cursor: initial;
  font-weight: 500;
`;

export const StyledIconLink = styled.a`
  display: flex;
  align-items: center;
`;

export const StyledExternalLink = styled.a`
  text-decoration: none;
  ${navTextSize};
  font-weight: 400;
  color: #696057;

  :hover {
    color: #ff5f00;
  }
`;

export const StyledLi = styled.li`
  ${StyledLink}, ${StyledExternalLink} {
    font-weight: 300;
  }

  line-height: 1.22em;
`;

export const StyledHamburger = styled(Hamburger)``;

export const NavWrapper = styled.div``;

export const NavTitle = styled.h3`
  color: #696057;
  margin: 0;
  cursor: pointer;
  ${StyledLink}, ${StyledExternalLink} {
    font-weight: 500;
  }
`;

export const IconsWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;

  > i {
    margin-left: 25px;
  }
`;

export const StyledIcon = styled(Icon)`
  display: inline-block;
  cursor: pointer;
  width: ${(p) => p?.width || "inherit"};
  height: ${(p) => p?.height || "inherit"};
`;

export const StyledLogo = styled(StyledIcon)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 8px;
`;

export const SocialLinkItem = styled.div`
  > a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const SocialLinkLabel = styled.div`
  font-size: 10px;
  line-height: 11px;
  margin-top: 4px;
  color: #000;

  ${media.mobile} {
    font-size: 0.5rem;
  }

  ${media.tablet} {
    font-size: 0.5rem;
  }

  ${media.desktop} {
    font-size: 0.64rem;
  }
`;

export const SocialLinksWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0;
  width: 90%;

  svg {
    width: 35px;
    height: 35px;
  }
`;

export const Container = styled.div`
  height: 60px;
  background: #f2f2f2;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;

  ${media.mobile} {
    ${Navbar} {
      width: 299px;
    }

    ${NavWrapper} {
      margin-bottom: 25px;
    }
  }

  ${media.tablet} {
    ${HeaderWrapper} {
      padding: 0 32px 0 18px;
    }

    ${Navbar} {
      width: 341px;
    }

    ${NavWrapper} {
      margin-bottom: 25px;
    }

    ${SocialLinksWrapper} {
      margin-top: 0;
    }
  }

  ${media.desktop} {
    ${Navbar} {
      width: 341px;
    }
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const SearchUl = styled.ul`
  position: absolute;
  background: #fff;
  max-height: 500px;
  overflow: auto;
  top: 100%;
  margin: 0;
  width: 343px;
  padding: 0;
  list-style-type: none;
  filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));
`;

export const SearchLi = styled.li`
  padding: 20px;
  display: flex;
  align-items: center;

  > i {
    width: 17px;
    height: 17px;
  }

  > a {
    margin-left: 8px;
    text-decoration: none;

    &:hover {
      color: #ff6000;
    }
  }
`;

export const SearchInput = styled.input`
  border: none;
  width: 262px;
  border-bottom: 1px solid #827c7b;
  background: #f2f2f2;
  outline: none;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #827c7b;
`;

export const SearchIconWrapper = styled.div``;
